export default {
  common: [
    "common_stock_handlebar_kit",
    "common_stock_handle",
    "common_stock_accessory",
    "common_stock_swaybar",
    "common_stock_side_panels",
    "common_parts",
    "common_stock_cluster",
  ],
  rally: [
    "MY22_rally",
    "MY22_sport_rally",
    "rally_parts",
    "rally_fender_front",
    "rally_stock_shock_rear",
    "rally_stock_mag_front",
    "rally_stock_mag_rear",
    "rally_stock_footpeg",
    "rally_stock_hood",
    "rally_stock_shock_front",
    "rally_stock_handlebar",
    "rally_stock_seat",
    "sport_rally_parts",
    "accessory_219401135_cruise_control_sport_rally_POSITION_IF_stock_handle",
    "accessory_219400998_Full_Wrap_Handguard_POSITION_IF_stock_handlebar_rally",
    "accessory_219400963_fender_rear rally",
    "accessory_219401028_full_body_skid_plate_rally",
    "accessory_219401108_front_bumper_rally",
    "accessory_219401137_mud_flap_rally",
    "accessory_219401169_Ryker_Max_Mount_Structure_rally_sport"
  ],
  sport: [
    "MY22_sport_rally",
    "MY22_sport",
    "MY22_600_900_sport",
    "600_900_sport_Stock_accessory",
    "sport_rally_parts",
    "sport_parts",
    "sport_stock_mag_front",
    "sport_stock_mag_rear",
    "sport stock_front_lip",
    "sport_stock_shock_rear",
    "600_900_sport_parts",
    "600_900_sport_stock_mudflap",
    "600_900_sport_footpeg",
    "600_900_sport_stock_handlebar",
    "600_900_sport_stock_hood",
    "accessory_219401135_cruise_control_sport_rally_POSITION_IF_stock_handle",
    "accessory_cruise_control_attache_sport_POSITION_IF_stock_handle",
    "accessory_219401169_Ryker_Max_Mount_Structure_rally_sport"
  ],
  base: [
    "MY22_600_900_sport",
    "MY22_base_600_900",
    "600_900_sport_parts",
    "600_900_sport_stock_mudflap",
    "600_900_sport_footpeg",
    "600_900_sport_stock_handlebar",
    "600_900_sport_stock_hood",
    "base_part",
    "base_stock_mag_front",
    "base_stock_mag_rear",
    "base_stock_seat",
    "base_stock_shock_front",
    "base_stock_shock_rear",
    "base_stock_body_spoiler",
    "base_stock_body_spoiler_left",
    "base_stock_body_spoiler_right",
  ],
  accessories: [
    // these aren't in the common section otherwise they will get stuck on when all common parts are turned on at the start
    "common_stock_handle_POSITION_IF_219400813",
    "common_stock_handle_POSITION_IF_219400847",
    /// begin new ///
    "accessory_219401135_cruise_control_sport_rally_POSITION_IF_stock_handle",
    "accessory_219401135_cruise_control_sport_rally_POSITION_IF_219400847",
    "accessory_219401135_cruise_control_sport_rally_POSITION_IF_219400813",
    "accessory_cruise_control_attache_sport_POSITION_IF_stock_handle",
    "accessory_219401137_mud_flap_rally",
    "accessory_219401108_front_bumper_rally",
    "accessory_219401146_705403043_puma_front_wheels",
    "accessory_219401165_705503339_puma_rear_wheel",
    "accessory_219401103_linq_plate_rack",
    "accessory_219401043_passenger_hand_deflector",
    "accessory_219401109_mini_sporty_floorboard",
    "accessory_219401033_audio_system",
    "accessory_219401026_linq_urban_bag",
    "accessory_219401104_Passenger_Comfort_Seat",
    /// end new ///
    "accessory_219400750_Passenger_Comfort_Seat",
    "accessory_219400762_Tank_Bag",
    "accessory_219400764_LinQ_Semi_Rigid_Top_Case",
    "accessory_219400765_helmet_bag",
    "accessory_219401023_Adjustable_Sport_Windshield",
    "accessory_219400795_Driver_Comfort_Seat",
    "accessory_219400796_219400940_GPS_Holder_Kit_POSITION_IF_stock_handlebar",
    "accessory_219400796_219400940_GPS_Holder_Kit_POSITION_IF_219400813",
    "accessory_219400796_219400940_GPS_Holder_Kit_POSITION_IF_219400847",
    "accessory_219400798_FOX_Quick_Adjust_Front_Shocks",
    "accessory_219400799_FOX_Quick_Adjust_Rear_Shock",
    "accessory_219400801_Passenger_Short_Rail",
    "accessory_219400803_basic_side_panels_deep_black",
    "accessory_219400804_basic_side_panels_can_am_red",
    "accessory_219400805_premium_side_panels_vegas_white",
    "accessory_219400809_premium_side_panels_carbon_black",
    "accessory_219400808_custom_body_panels_deep_black_can_am_red",
    "accessory_219400810_Sport_Grips_Black_POSITION_IF_stock_handlebar",
    "accessory_219400810_Sport_Grips_Black_POSITION_IF_219400813",
    "accessory_219400810_Sport_Grips_Black_POSITION_IF_219400847",
    "accessory_219400998_Full_Wrap_Handguard_POSITION_IF_stock_handlebar_rally",
    "accessory_219400998_Full_Wrap_Handguard_attache_POSITION_IF_stock_handlebar",
    "accessory_219400998_Full_Wrap_Handguard_attache_POSITION_IF_stock_handlebar_rally",
    "accessory_219400998_Full_Wrap_Handguard_POSITION_IF_219400813",
    "accessory_219400998_Full_Wrap_Handguard_attache_POSITION_IF_219400813",
    "accessory_219400998_Full_Wrap_Handguard_POSITION_IF_219400847",
    "accessory_219400998_Full_Wrap_Handguard_attache_POSITION_IF_219400847",
    "accessory_219400813_Sport_Handlebar",
    "accessory_219400817_Splash_Guard",
    "accessory_219400818_gauge_spoiler",
    "accessory_219400819_swaybar",
    "accessory_219400820_Handguard_Accent_Lighting_POSITION_IF_stock_handlebar",
    "accessory_219400820_Handguard_Accent_Lighting_POSITION_IF_219400813",
    "accessory_219400820_Handguard_Accent_Lighting_POSITION_IF_219400847",
    "accessory_219400825_wheel_accents_black",
    "accessory_219400833_knee_pads",
    "accessory_219400841_Smartphone_Holder_POSITION_IF_stock_handlebar",
    "accessory_219400841_Smartphone_Holder_POSITION_IF_219400813",
    "accessory_219400841_Smartphone_Holder_POSITION_IF_219400847",
    "accessory_219400842_Passenger_Seat",
    //   "accessory_219400842_Passenger_Seat_losange_seat_01",
    "accessory_219400843_Foldable_Passenger_Backrest",
    "accessory_219400844_SHAD_Rigid_Saddlebag",
    "accessory_219400847_All_Road_Handlebar",
    "accessory_219400848_LED_Auxiliary_Light_black",
    "accessory_219400856_Saddlebag_Rack",
    "accessory_219400856_Saddlebag_Rack_REMOVE_IF_219401169_structure_1_1",
    "accessory_219400861_Wheel_Decals_White",
    "accessory_219400869_rear_spoiler_black",
    "accessory_219400870_rear_spoiler_Red",
    "accessory_219400871_rear_spoiler_Yellow",

    "accessory_219400876_Premium_Hood_Vegas_White",
    "accessory_219400877_Premium_Hood_Carbon_Black",
    "accessory_219400894_Handguard_Deflector_POSITION_IF_stock_handlebar",
    "accessory_219400894_REMOVE_IF_219400820_POSITION_IF_stock_handlebar",
    "accessory_219400894_Handguard_Deflector_POSITION_IF_219400813",
    "accessory_219400894_REMOVE_IF_219400820_POSITION_IF_219400813",
    "accessory_219400894_Handguard_Deflector_POSITION_IF_219400847",
    "accessory_219400894_REMOVE_IF_219400820_POSITION_IF_219400847",
    "accessory_219400916_gauge_spoiler_decal_white",
    "accessory_219400917_gauge_spoiler_decal_Red",
    "accessory_219400918_gauge_spoiler_decal_Green",
    "accessory_219400919_Sport_Grips_red_POSITION_IF_stock_handlebar",
    "accessory_219400919_Sport_Grips_red_POSITION_IF_219400813",
    "accessory_219400919_Sport_Grips_red_POSITION_IF_219400847",
    "accessory_219400920_wheel_accents_red",
    "accessory_219400921_Wheel_Decals_red",
    "accessory_219400922_Wheel_Decals_Boreal_Green",
    "accessory_219400923_premium_side_panels_liquid_metal",
    "accessory_219400924_premium_body_panels_long_beach_blue",
    "accessory_219400925_premium_body_panels_phoenix_orange",
    "accessory_219400926_premium_body_panels_neon_yellow",
    "accessory_219400927_custom_body_panels_authentic_white",
    "accessory_219400928_basic_side_panels_yellow",
    "accessory_219400929_custom_body_panels_boreal_green",
    "accessory_219400933_Wheel_Decals_Long_Beach_Blue",
    "accessory_219400934_Wheel_Decals_Phoenix_Orange",
    "accessory_219400935_Wheel_Decals_Neon_Yellow",
    "accessory_219400936_gauge_spoiler_decal_Long_Beach_Blue",
    "accessory_219400937_gauge_spoiler_decal_Phoenix_Orange",
    "accessory_219400938_gauge_spoiler_decal_Neon_Yellow",
    "accessory_219400939_1_1_Structure_cap",
    "accessory_219400977_gauge_spoiler_volcan_grey",
    "accessory_219400982_wheel_decals_volcan_grey",
    "accessory_219401009_gauge_spoiler_electron_green",
    "accessory_219401010_wheel_decals_electron_green",
    "accessory_219401016_gauge_spoiler_decal_liquid_titan",
    "accessory_219401017_wheel_decals_liquid_titan",
    "accessory_219400980_pod_decal",
    "accessory_219400986_Wheel_Decals",
    "accessory_219400948_Cluster_Relocator",
    "accessory_219400960_1up_Driver_Backrest",
    "accessory_219400962_Solo_Driver_Comfort_Seat",
    "accessory_219400963_fender_rear_rally",
    "accessory_219400964_LinQ_Thermal_Box",
    "accessory_219400965_Ryker_LinQ_Rack",
    "accessory_219400999_Radiator_Protector",
    "accessory_219401001_Mono_Seat_Cowl",
    "accessory_715002875_LinQ_Dry_Bag",
    "accessory_715003059_LinQ_Tool_Holders",
    "accessory_860201678_LinQ_Sport_Bag",
    "accessory_860201740_LinQ_SR21_Tunnel_Bag",
    "accessory_219400947_Front_Grill_Trims",
    "accessory_219401070_panel_kit",
    "accessory_219401067_exclusive_panel_kit_black_monolith_white",
    "accessory_219401071_panel_kit",
    "accessory_219401032_windshield",
    "accessory_219401028_full_body_skid_plate_rally",
    "accessory_219401025_intake_prefilter",
    "accessory_219401039_LinQ_Sport_Bag",

    "accessory_cruise_control_attache_sport_POSITION_IF_219400847",
    "accessory_cruise_control_attache_sport_POSITION_IF_219400813",

    // New Side Panels and hood accent updated models the previous ones were not removed
    "accessory_219401133_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401134_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401064_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401072_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400987_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400988_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400989_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401004_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401002_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401003_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401006_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401070_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400941_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400943_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401071_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219400942_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401005_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401015_600_900_SPORT_AR_exclusive_side_panels",

    "accessory_219401133_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401134_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401064_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401072_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400987_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400988_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400989_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401004_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401002_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401003_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401006_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401070_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400941_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400943_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401071_600_900_SPORT_exclusive_hood_accent",
    "accessory_219400942_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401005_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401015_600_900_SPORT_exclusive_hood_accent",
    
    "accessory_219401133_AR_exclusive_hood_accent",
    "accessory_219401134_AR_exclusive_hood_accent",
    "accessory_219401064_AR_exclusive_hood_accent",
    "accessory_219401072_AR_exclusive_hood_accent",
    "accessory_219400987_AR_exclusive_hood_accent",
    "accessory_219400988_AR_exclusive_hood_accent",
    "accessory_219400989_AR_exclusive_hood_accent",
    "accessory_219401004_AR_exclusive_hood_accent",
    "accessory_219401002_AR_exclusive_hood_accent",
    "accessory_219401003_AR_exclusive_hood_accent",
    "accessory_219401006_AR_exclusive_hood_accent",
    "accessory_219401070_AR_exclusive_hood_accent",
    "accessory_219400941_AR_exclusive_hood_accent",
    "accessory_219400943_AR_exclusive_hood_accent",
    "accessory_219401071_AR_exclusive_hood_accent",
    "accessory_219400942_AR_exclusive_hood_accent",
    "accessory_219401005_AR_exclusive_hood_accent",
    "accessory_219401015_AR_exclusive_hood_accent",

    "accessory_219400873_600_900_SPORT_basic_hood_accent_black",
    "accessory_219400874_600_900_SPORT_basic_hood_accent_red",
    "accessory_219400875_600_900_SPORT_basic_hood_accent_yellow",

    "accessory_219400873_AR_basic_hood_accent_black",
    "accessory_219400874_AR_basic_hood_accent_red",
    "accessory_219400875_AR_basic_hood_accent_yellow",
    // 2023 New updates
    "accessory_219401115_Heated_Grips_POSITION_IF_219400847",
    "accessory_219401115_Heated_Grips_POSITION_IF_219400813",
    "accessory_219401115_Heated_Grips_POSITION_IF_stock_handlebar",
    "accessory_219401144_Windshield_Kit_for_Audio",
    "accessory_219401156_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401156_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401156_AR_exclusive_hood_accent",
    "accessory_219401157_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401157_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401157_AR_exclusive_hood_accent",
    "accessory_219401158_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401158_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401158_AR_exclusive_hood_accent",
    "accessory_219401159_Front_Wheel",
    "accessory_219401160_Rear_Wheel",
    "accessory_219401161_Additionnal_Grill",
    "accessory_219401164_Driver_Backrest_STD_Rally",
    "accessory_219401167_600_900_SPORT_AR_exclusive_side_panels",
    "accessory_219401167_600_900_SPORT_exclusive_hood_accent",
    "accessory_219401167_AR_exclusive_hood_accent",
    "accessory_219401169_Ryker_Max_Mount_Structure_rally_sport",
    "accessory_715005494_LinQ_Modular_Box",
  ],
};



// WEBPACK FOOTER //
// ./src/managers/Model/partInfoMY22.js